<div class="rounded-xl overflow-hidden shadow-lg">

  <!-- Header -->
  <div class="dialog-header flex items-center justify-center">
    Move Registrations to Application
    <div class="absolute right-4">
      <button (click)="handleCloseDialog()" class="text-white hover:text-gray-300">
        <i class="pi pi-times"></i>
      </button>
    </div>
  </div>

  <!-- Content -->
  <div class="dialog-content p-6 text-center">
    <!-- Move Icon -->
    <i class="pi pi-file-export text-5xl text-gray-600 mb-4" style="font-size: 27px;"></i>

    <!-- Title -->
    <div class="font-semibold text-xl mb-4">
      Are you sure you want to move selected registrations to application?
    </div>

    <!-- Registration Count -->
    <div class="text-gray-600 mb-3">
      Selected Registrations: <span class="font-medium">{{ selectedProducts?.length }}</span>
    </div>

    <!-- Buttons -->
    <div class="flex gap-4 mt-7 justify-center">
      <p-button label="Cancel" severity="danger" variant="outlined" (click)="handleCloseDialog()">
      </p-button>

      <p-button label="Move To Application" icon="pi pi-file-export" 
                (click)="handleMove()" [disabled]="isLoading" [loading]="isLoading">
      </p-button>
    </div>
  </div>
</div>
